const storeState = {
  tablets: [],
};

const mutations = {
  pushTablet(state, tv) {
    state.tablets.push(tv);
  },
  setTablets(state, tvs) {
    state.tablets = tvs;
  },
  editTablet(state, data) {
    state.tablets[data.index] = data.tv;
  },
  removeTablet(state, index) {
    state.tablets.splice(index, 1);
  },
};

const getters = {
  tablet_tvs() {
    return storeState.tablets;
  },
};

const actions = {
  tablet_setTvs({ commit }, tvs) {
    commit('setTablets', tvs);
  },
  tablet_pushTv({ commit }, tv) {
    commit('pushTablet', tv);
  },
  tablet_editTv({ commit }, data) {
    commit('editTablet', data);
  },
  tablet_removeTv({ commit }, index) {
    commit('removeTablet', index);
  },
};

export default {
  state: storeState,
  mutations,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/tablet.js